import Swiper from "swiper"




export default function instagramApi(){

    jQuery.fn.FCInstagram.accessData = {
        accessToken: "IGAASPEiRjZBYFBZAGFraDkxMGdkMDdGejNvVWJRUFpva0pYeFU0aVF6aTg5OEpndGNsOUVOai10QTJhLXdkLXJvVDVCRWIyWFA4d3g2VXJUdVBfWnR2TkZApMWI0WGxKWG1WLU82YnRpLVlYQVV5N3JYS3NLT1JoSjJ6YnlDbU1nWQZDZD", 
        // Token
    };
   
    $('#instafeed').FCInstagram({
        max: 10, // A number between 1 and 25 of photos to show. Default: 9
        autoplay: false, // Set autoplay video: true/false. Default: false
        complete: function () { // A callback function to execute after the display of the photos.
            console.log('completed');

            const instaItems = document.querySelectorAll('#instafeed a')
            const instaWrapper = document.querySelector('#instafeed')

            const htmlSlide = [...instaItems].map(item => {
                return `
                <div  class="swiper-slide">
                        <span style="visibility:hidden">-</span>
                        <div>
                            ${item.outerHTML}    
                            <div class="content">
                            <svg>
                                <use xlink:href="#icon_instagram_white"></use>
                            </svg>
                            <span class="text-caps-2">Ver no instagram</span>
                            </div>
                        </div>
                </div>
                `
            }).join('')

            instaWrapper.innerHTML = `          
            <div class="swiper swiper-acompanhe-nos" style="display: grid; width:100%;">
                <div class="swiper-wrapper scrollCarosell">
                ${htmlSlide}
                </div>
            </div>
            `

            const swiperAcompanhe = new Swiper(".swiper-acompanhe-nos", {
                // lazy:true,
                // slidesPerView: 1.2,
                // spaceBetween: 8,

                // allowTouchMove: true,
				// allowTouch: true,


                // loop: true,

                // allowTouchMove: true,
				// allowTouch: true,
				
				// breakpoints: {
				// 	220: {
				// 		speed: 0,
				// 	},

				// 	1024: {
				// 		speed: 300,
		
				// 	},	
				// },

				


				// autoplay: {
				// 	delay: 1,
				// 	pauseOnMouseEnter: true,
				// 	disableOnInteraction: false // Set this to false
				// },
				

               
                preloadImages: false,
                        
                loop: true,
                spaceBetween: 16,
                watchSlidesProgress: true,
                grabCursor: true,
                slideToClickedSlide:true,
                centeredSlides:false,

                
                centeredSlidesBounds:true,


				allowTouchMove: true,
				allowTouch: true,
				
				

				


				autoplay: {
					delay: 1,
					pauseOnMouseEnter: true,
					disableOnInteraction: false // Set this to false
				},


				

				


				

                // centeredSlides:true,
                // centeredSlidesBounds:true,

								breakpoints: {
									220:{
										slidesPerView:2,
                                        speed: 0,
									},
									1024:{
                                        speed: 6000,
										slidesPerView:4,
									},
								}
               
                // autoplay:{
                //     delay: 3000
                // }
               
            });
        }
    });  

  
}